import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';

const LineChartMetric = ({ metricField, metricData, channels }) => {
	const colors = [
		'#3366CB',
		'#DC3912',
		'#F69906',
		'#7c5cdb',
		'#ce5cdb',
		'#db5c97',
		'#9fc934',
		'#60d17e',
	];

	const [currentData, setCurrentData] = useState([]);
	const [rowsData, setRowsData] = useState([]);
	const [labels, setLabels] = useState([]);

	// console.log('metricData', metricData);

	useEffect(() => {
		if (metricData) {
			setRowsData(metricData.lineData2);
		}
	}, [metricData]);

	useEffect(() => {
		if (rowsData) {
			let labels;
			const data = [];
			const allData = rowsData.map((e, i) => {
				if (e.labels) {
					labels = e.labels;
				}
				if (!e.data) return;
				data.push(e);
			});
			const mapData = data.map((e, i) => {
				return {
					label: e.label,
					fill: false,
					data: e.data,
					borderColor: colors[i], // The main line color
					pointRadius: 0,
					pointHitRadius: 10,
					borderWidth: 2,
					lineTension: 0.3,
				};
			});

			setLabels(labels);
			setCurrentData(mapData);
		}
	}, [rowsData]);

	// console.log('currentData', currentData);
	// console.log('metricData', metricData);
	// console.log('labels', labels);
	// console.log('rowsData2', rowsData);

	const data = {
		labels: labels,
		datasets: currentData,
	};

	var options = {
		// animation: false,
		scales: {
			// yAxes: [
			// 	{
			// 		ticks: {
			// 			beginAtZero: true,
			// 		},
			// 		scaleLabel: {
			// 			display: true,
			// 			labelString: 'Moola',
			// 			fontSize: 20,
			// 		},
			// 	},
			// ],
			y: {
				suggestedMin: -1,
			},
			x: {
				ticks: {
					maxTicksLimit: 10,
				},
			},
		},

		plugins: {
			title: {
				display: true,
				text: 'Metrics',
				font: {
					size: '20px',
				},
			},
			legend: { display: true },
		},
		maintainAspectRatio: false,
	};

	return (
		<div>
			<Line data={data} options={options} width={300} height={350} />
		</div>
	);
};

export default LineChartMetric;
